module.exports = __webpack_public_path__ + "img/people.4baad98a.svg";